import React, { Suspense } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import routes from "./routes";
import Loading from "./components/Game/components/Loading";
import { Toaster } from "react-hot-toast";
import styles from "./App.module.scss";

const Lobby = React.lazy(() => import("./components/Lobby"));
const Home = React.lazy(() => import("./components/Home"));
const Game = React.lazy(() => import("./components/Game"));
const Spectate = React.lazy(() => import("./components/Game/Spectate"));
const VideoTest = React.lazy(() => import("./components/VideoTest"));

const App = () => {
  return (
    <div className={styles.Ass}>
      <Router>
        <Suspense fallback={<Loading />}>
          <Switch>
            <Route exact path={routes.home}>
              <Home />
            </Route>
            <Route exact path={`${routes.lobby}/:id`}>
              <Lobby />
            </Route>
            <Route exact path={`${routes.game}/:id`}>
              <Game />
            </Route>
            <Route exact path={`${routes.spectate}/:id`}>
              <Spectate />
            </Route>
            <Route exact path={routes.videoTest}>
              <VideoTest />
            </Route>
            <Route path="*">
              <div>404</div>
            </Route>
          </Switch>
        </Suspense>
      </Router>
      <Toaster position={"top-center"} />
    </div>
  );
};

export default App;

// const AssClient = Client({
//   game: Ass,
//   numPlayers: 3,
//   board: AssBoard,
//   multiplayer: SocketIO({ server: "localhost:8000" }),
// });

// const App = () => (
//   <div>
//     <AssClient playerID="0" />
//     <AssClient playerID="1" />
//     <AssClient playerID="2" />
//   </div>
// );
